import type { ContractAppProfileDto } from "src/app/features/Contract/types/subTypes/ContractAppProfileDto";
import { AcceptMode } from "src/app/features/Contract/types/subTypes/ContractAppProfileEntity";
import type { ContractTerminalEntity } from "src/app/features/Contract/types/subTypes/ContractTerminalEntity";
import {
    deriveAllFlags,
    getSiteTerminalsFromCache,
} from "../../../../../components/Form/formComponents/ContractsTerminalsTable/ContractTerminalsTableUtils";
import type { ContractDto } from "../../types/ContractDto";
import type { ContractEntity } from "../../types/ContractEntity";

export const ContractEntityToDto = ({
    acceptedCardProfiles,
    physicalAppProfilesCheckReadOnly: _physicalAppProfilesCheckReadOnly, // remove property, not sent to BE
    acceptedCardProfilesCheckReadOnly: _acceptedCardProfilesCheckReadOnly, // remove property, not sent to BE
    acquirerIdCheckReadOnly: _acquirerIdCheckReadOnly,
    appProfileListIdCheckReadOnly: _appProfileListIdCheckReadOnly,
    // Strip UI-only checkbox values - they are re-derived below from actual terminal selection
    allIPT: _allIPT,
    allOPT: _allOPT,
    allUnattended: _allUnattended,
    allEcommerce: _allEcommerce,
    allEvcharger: _allEvcharger,
    terminals,
    siteId,
    ...rest
}: Readonly<ContractEntity>): ContractDto => {
    const newContractAppProfiles: ContractAppProfileDto[] =
        acceptedCardProfiles?.map(({ acceptMode, ...contractAppProfile }) => {
            const degraded = acceptMode === AcceptMode.DEGRADED.value;
            const offline = acceptMode === AcceptMode.OFFLINE.value || degraded;
            const online = acceptMode === AcceptMode.ONLINE.value || offline || degraded;

            return { ...contractAppProfile, online, offline, degraded };
        }) || [];

    const allSiteTerminals = getSiteTerminalsFromCache(siteId);
    const allFlags = deriveAllFlags(terminals as ContractTerminalEntity[], allSiteTerminals);

    return { ...rest, siteId, acceptedCardProfiles: newContractAppProfiles, terminals, ...allFlags };
};
